exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-500[data-v-44b8d0a3]{font-weight:500}#PurchaseEnquiryValidationModalView .modal-dialog[data-v-44b8d0a3],#PurchaseEquiryValidationModalEdit .modal-dialog[data-v-44b8d0a3]{min-width:80%}", ""]);

// exports
